import {makeAutoObservable} from "mobx";
import {
    RoleModuleStoreInterface,
    TranslationModuleStoreInterface,
    UserModuleStoreInterface,
    ServicerModuleStoreInterface,
    AgencyModuleStoreInterface, BankModuleStoreInterface, OtherCompanyModuleStoreInterface
} from "../types";
import RoleStore from "./module/role.store";
import {RoleService} from "../service/module/role.service";
import {TranslationStore} from "./module/translation.store";
import {TranslationService} from "../service/module/translation.service";
import UserStore from "./module/user.store";
import {UserService} from "../service/module/user.service";
import {AppStore} from "./app.store";
import ServicerStore from "./module/servicer.store";
import {ServicerService} from "../service/module/servicer.service";
import {AgencyService} from "../service/module/agency.service";
import AgencyStore from "./module/agency.store";
import BankStore from "./module/bank.store";
import {BankService} from "../service/module/bank.service";
import OtherCompanyStore from "./module/otherCompany.store";
import {OtherCompanyService} from "../service/module/otherCompany.service";

export class ModuleStore {
    public roleStore: RoleModuleStoreInterface;
    public translationStore: TranslationModuleStoreInterface
    public userStore: UserModuleStoreInterface
    public servicerStore: ServicerModuleStoreInterface
    public agencyStore: AgencyModuleStoreInterface
    public bankStore: BankModuleStoreInterface
    public otherCompanyStore: OtherCompanyModuleStoreInterface

    constructor(appStore: AppStore) {
        makeAutoObservable(this);
        this.roleStore = new RoleStore(appStore, new RoleService());
        this.translationStore = new TranslationStore(appStore, new TranslationService());
        this.userStore = new UserStore(appStore, new UserService());
        this.servicerStore = new ServicerStore(appStore, new ServicerService());
        this.agencyStore = new AgencyStore(appStore, new AgencyService());
        this.bankStore = new BankStore(appStore, new BankService());
        this.otherCompanyStore = new OtherCompanyStore(appStore, new OtherCompanyService());
    }
}